import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class MassCommunicationRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/mass-communications(/)")
    route () {
        System.import("./index").then(View => {
            const view = new View.default();

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default MassCommunicationRoute;



// WEBPACK FOOTER //
// ./public/domain/views/mass-communication/mass-communication.route.js